// export const SERVICE_EVENTS_CONTAINER_TITLE = 'Service Events';
// export const SERVICE_EVENT_LIST_TITLE = 'Service Events';
// export const NEW_SERVICE_EVENT_TITLE =  'New Service Event';
export const ADD_PROJECT_TITLE = 'New Project';
export const ADD_DUPLICATE_PROJECT_TITLE = 'Edit Duplicate Project';
export const EDIT_PROJECT_TITLE = 'Project Details';
export const ADD_USER_TITLE = 'New User';
export const EDIT_USER_TITLE = 'Edit User';
export const EDIT_PRODUCT_TITLE = 'Edit Product Item';
// export const ADD_PRODUCT_TITLE = 'Add Product Item';
// export const EDIT_MATERIAL_TITLE = 'Edit Material Item';
// export const ADD_MATERIAL_TITLE = 'Add Material Item';
export const EDIT_SERVICE_TITLE = 'Edit Service';
export const ADD_SERVICE_TITLE = 'Add Service Item';
// export const EDIT_SERVICE_EVENT_TITLE = 'Edit Service Event';
// export const EDIT_TOUCH_POINT_TITLE = 'Edit Touch Point';
// export const EDIT_TOUCH_POINT_LOCATION_TITLE = 'Edit Touch Point Project';
// export const ADD_TOUCH_POINT_TITLE = 'Add Touch Point'; // component shared with Edit
// export const TOUCH_POINT_LIST_TITLE = 'Touch Points';
export const EDIT_INSTALLATION_TITLE = 'Edit ServicePoint';
export const ADD_INSTALLATION_TITLE = 'Add ServicePoint'; // component shared with Edit
